<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     布局模板 Frame 组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="the-layout-frame" :class="{ 'is-collapse': isCollapse }">
    <el-scrollbar :native="false">
      <div class="frame-container">
        <div class="home flex-center" role="button" :class="{ 'is-collapse': isCollapse, 'is-active': $route.name === 'HomeIndex' }" @click="homeSelect()">
          <div v-show="!isCollapse" class="logo flex-center">
            <img v-if="logo" :src="logo">
            <img v-else src="@/assets/logo.png">
          </div>

          <div v-show="isCollapse" class="o-icon flex-center column">
            <i class="iconfont icon-Home frame-icon"></i>
            <div class="title">{{ '总览' }}</div>
          </div>
        </div>

        <template v-for="frame in frames">
          <div
            v-if="frame.meta.show === 1"
            :key="frame.meta.frame"
            class="frame-item"
            :class="{ 'is-active': frame.meta.frame === defaultActive }"
            @click="frameSelect(frame)">
            <div class="o-icon flex align-items-center">
              <i :class="'iconfont frame-icon icon-' + frame.meta.frame"></i>
              <div v-if="!isCollapse" class="s-title">{{ frame.meta.abbr }}</div>
            </div>
            <div v-if="isCollapse" class="title">{{ frame.meta.abbr }}</div>
          </div>
        </template>
      </div>
    </el-scrollbar>
    <div class="fold flex-center text-white" @click="toggleMenu()">
      <i v-if="isCollapse" role="button" class="iconfont icon-unfold"></i>
      <i v-else role="button" class="iconfont icon-fold"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLayoutFrame',
  data() {
    return {
    }
  },
  computed: {
    route() {
      return this.$route
    },
    logo() {
      return this.$store.state.godStore.customization ? this.$store.state.godStore.customization.console_imgurl : ''
    },
    short_name() {
      return this.$store.state.godStore.short_name
    }, 
    isCollapse() {
      return this.$store.state.commonStore.collapse
    },
    defaultActive() {
      return this.$store.getters.currentFrame.frame
    },
    frames() {
      return this.$store.getters.dynamicRoutes
    }
  },
  methods: {
    homeSelect() {
      this.$router.push({ name: 'HomeIndex' })
    },

    frameSelect(frame) {
      this.$router.push({ name: frame.meta.frame })
    },

    toggleMenu () {
			this.$store.commit("SET_COLLAPSE", this.isCollapse ? 0 : 1);
		},
  }
}
</script>

<style lang="scss">
$--color-primary: #07c160;
$--menu-inverse-bg: #252a2f;
$--menu-inverse-item-color: #ccc;
$--menu-inverse-item-hover-fill: mix(#000, $--menu-inverse-bg, 20%);
.the-layout-frame {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 160px;
  background-color: $--menu-inverse-bg;
  overflow-x: hidden;
  .frame-container {
    border: 0;
    margin-top: -1px;
    background-color: $--menu-inverse-bg;
    .home {
      width: 160px;
      height: 60px;
      color: $--menu-inverse-item-color;
      transition: all .2s;
      .logo {
        margin: 5px;
        img {
          max-height: 50px;
          max-width: 140px;
        }
        .title {
          font-size: 16px;
          line-height: 20px;
        }
      }
      .o-icon {
        width: 160px;
        font-size: 28px;
        line-height: 1em;
        color: inherit;
        text-align: center;
        .title {
          display: none;
          width: 160px;
          font-size: 12px;
          line-height: 16px;
        }
        .frame-icon {
          font-size: 28px;
        }
      }
      &:hover, &:focus {
        color: #fff;
        background-color: $--menu-inverse-item-hover-fill;
        .o-icon {
          padding-top: 8px;
          .title {
            display: block;
          }
        }
      }
      &.is-active {
        color: $--color-primary;
        // border-left: 2px solid $--color-primary;
      }
      &.is-collapse {
        width: 60px;
      }
    }
    .frame-item {
      cursor: pointer;
      text-align: center;
      height: 60px;
      line-height: 1em;
      padding: 0;
      color: $--menu-inverse-item-color;
      transition: all .2s;
      .o-icon {
        width: 160px;
        padding-top: 16px;
        font-size: 28px;
        line-height: 1em;
        color: inherit;
        transition: padding .2s;
        .s-title {
          display: block;
          font-size: 14px;
        }
        .frame-icon {
          font-size: 28px;
          width: 60px;
        }
      }
      &:hover, &:focus {
        color: #fff;
        background-color: $--menu-inverse-item-hover-fill;
      }
      &.is-active {
        color: $--color-primary;
        // border-left: 2px solid $--color-primary;
      }
    }
  }
  .fold {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 60px;
    color: $--menu-inverse-item-color;
    >i {
      font-size: 28px;
    }
    &:hover, &:focus {
      color: #fff;
      background-color: $--menu-inverse-item-hover-fill;
    }
  }
  >.el-scrollbar {
    height: 100%;
    >.is-horizontal {
      display: none;
    }
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 60px 0;
      }
    }
  }
}

.the-layout-frame.is-collapse {
  width: 60px;
  .frame-container {
    .home {
      width: 60px;
    }
    .frame-item {
      
      .o-icon {
        width: 60px;
        padding-top: 16px;
        font-size: 28px;
        line-height: 1em;
        color: inherit;
        transition: padding .2s;
        .title {
          font-size: 12px;
          line-height: 16px;
          transition: .2s;
        }
        .frame-icon {
          font-size: 28px;
          width: 60px;
        }
      }
      .title {
        display: none;
        width: 60px;
        font-size: 12px;
        line-height: 16px;
        transition: .2s;
      }
      &:hover, &:focus {
        color: #fff;
        background-color: $--menu-inverse-item-hover-fill;
        .o-icon {
          padding-top: 8px;
        }
        .title {
          display: block;
        }
      }
      &.is-active {
        color: $--color-primary;
        // border-left: 2px solid $--color-primary;
      }
    }
    
  }
  >.el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 60px 0;
      }
    }
  }
}
</style>
